<script setup lang="ts">
import Alert from '../../UI/Alert.vue'
import { useI18n } from 'vue-i18n'
import { AlertType } from '../../../../../Constants/AlertType.ts'

const { t } = useI18n()
</script>

<template>
  <Alert :type="AlertType.WARNING">
    {{ t('delivery.alerts.fill_delivery_date_to_upload_documents') }}
  </Alert>
</template>
